// Content for the Press page (Hi Tours) – India-focused press mentions and releases.
export const press = {
  pageTitle: 'Press & Media | Hi Tours',
  h1: 'Press & Media',
  intro: 'Hi Tours is one of India’s most trusted names in tailor-made international travel. From honeymoons in the Maldives to Himalayan journeys in Bhutan, our trips and travel experts are regularly featured across India’s leading media. For interviews, images or expert commentary, our press team is here to help.',
  statsHeading: 'Hi Tours at a glance',
  stats: [
    { value: '1,50,000+', label: 'Delighted Indian travellers' },
    { value: '25+', label: 'Years crafting journeys from India' },
    { value: '4.8/5', label: 'Average traveller rating' },
    { value: '40+', label: 'Destinations worldwide' }
  ],
  featuredHeading: 'As featured in',
  featured: ['The Times of India', 'The Economic Times', 'Condé Nast Traveller India', 'Outlook Traveller', 'The Hindu', 'Mint', 'Travel + Leisure India', 'Hindustan Times'],
  releasesHeading: 'Latest press releases',
  releases: [
    {
      date: '20 May 2026',
      tag: 'Company News',
      title: 'Hi Tours crosses 1.5 lakh Indian travellers served',
      excerpt: 'Mumbai-headquartered Hi Tours announced it has now crafted tailor-made holidays for over 1,50,000 Indian travellers, with the Maldives, Vietnam and Thailand emerging as the most-booked destinations for honeymooners and families this season.'
    },
    {
      date: '2 April 2026',
      tag: 'New Destination',
      title: 'Hi Tours launches curated Maldives honeymoon collection',
      excerpt: 'Responding to surging demand from Indian couples, Hi Tours unveiled a new Maldives collection featuring overwater villas, seaplane transfers and private sandbank dinners, with dedicated experts and 24x7 WhatsApp support for travellers.'
    },
    {
      date: '15 January 2026',
      tag: 'Industry Recognition',
      title: 'Hi Tours wins “Best Tailor-made Tour Operator” at India travel awards',
      excerpt: 'Hi Tours was recognised for its personalised service and local expertise, with the jury highlighting its India-based travel experts and seamless visa, permit and on-ground support across Asia, Africa and the Middle East.'
    },
    {
      date: '8 November 2025',
      tag: 'Festive Travel',
      title: 'Diwali break sees record bookings for Bhutan and Sri Lanka',
      excerpt: 'Hi Tours reported a sharp rise in short-haul festive getaways, with Indian families choosing Bhutan’s Tiger’s Nest trek and Sri Lanka’s tea country for the long Diwali weekend.'
    }
  ],
  contactHeading: 'Media enquiries',
  contactText: 'For press enquiries, interviews, high-resolution images or expert commentary on Indian outbound travel trends, please get in touch with our media desk.',
  contactName: 'Hi Tours Media Desk',
  contactEmail: 'press@hitours.in',
  contactPhone: '+91 89206 06060'
};
